import {
  DuplicateContactException,
  ExceptionWithMessage,
} from 'shared/helpers/CustomErrors';
import types from '../../mutation-types';
import ContactAPI from '../../../api/contacts';
import LabelsAPI from "../../../api/labels";
import ContactSearchAPI from "../../../api/contactsSearch";
import AccountActionsAPI from '../../../api/accountActions';

export const actions = {
    downloadContactReports: async ({commit}) => {
        return ContactAPI.exportContacts()
            .then(response => {
                let csvContent =  response.data;
                var link = window.document.createElement("a");
                link.setAttribute("href", "data:text/csv;charset=utf-8,%EF%BB%BF" + encodeURI(csvContent));
                link.setAttribute("download", "contacts.csv");
                window.document.body.appendChild(link);
                link.click();
            })
            .catch(error => {
                console.error(error);
            });
    },
  get: async ({ commit, state }, { page = 1, sortAttr, label, filter_tags }) => {
    commit(types.SET_CONTACT_UI_FLAG, { isFetching: true });
    try {
      const { data: { payload, meta } } = await ContactAPI.get(page, sortAttr, label, filter_tags);
      if (page === 1) {
        commit(types.CLEAR_CONTACTS);
      }
      commit(types.SET_CONTACTS, payload);
      commit(types.SET_CONTACT_META, meta);
      commit(types.SET_CONTACT_UI_FLAG, { isFetching: false });
    } catch (error) {
      commit(types.SET_CONTACT_UI_FLAG, { isFetching: false });
    }
  },

  search: async ({ commit, state }, { search, page = 1, sortAttr, label, filter_tags }) => {
    commit(types.SET_CONTACT_UI_FLAG, { isFetching: true });
    try {
      const { data: { payload, meta } } = await ContactAPI.search(search, page, sortAttr, label, filter_tags);
      if (page === 1) {
        commit(types.CLEAR_CONTACTS);
      }
      commit(types.SET_CONTACTS, payload);
      commit(types.SET_CONTACT_META, meta);
      commit(types.SET_CONTACT_UI_FLAG, { isFetching: false });
    } catch (error) {
      commit(types.SET_CONTACT_UI_FLAG, { isFetching: false });
    }
  },

  show: async ({ commit }, { id }) => {
    commit(types.SET_CONTACT_UI_FLAG, { isFetchingItem: true });
    try {
      const response = await ContactAPI.show(id);
      commit(types.SET_CONTACT_ITEM, response.data.payload);
      commit(types.SET_CONTACT_UI_FLAG, {
        isFetchingItem: false,
      });
    } catch (error) {
      commit(types.SET_CONTACT_UI_FLAG, {
        isFetchingItem: false,
      });
    }
  },

  update: async ({ commit }, { id, ...updateObj }) => {
    commit(types.SET_CONTACT_UI_FLAG, { isUpdating: true });
    try {
      const response = await ContactAPI.update(id, updateObj);
      commit(types.EDIT_CONTACT, response.data.payload);
      commit(types.SET_CONTACT_UI_FLAG, { isUpdating: false });
    } catch (error) {
      commit(types.SET_CONTACT_UI_FLAG, { isUpdating: false });
      if (error.response?.data?.contact) {
        throw new DuplicateContactException(error.response.data.contact);
      } else {
        throw new Error(error);
      }
    }
  },

  create: async ({ commit }, userObject) => {
    commit(types.SET_CONTACT_UI_FLAG, { isCreating: true });
    try {
      const response = await ContactAPI.create(userObject);
      commit(types.SET_CONTACT_ITEM, response.data.payload.contact);
      commit(types.SET_CONTACT_UI_FLAG, { isCreating: false });
    } catch (error) {
      commit(types.SET_CONTACT_UI_FLAG, { isCreating: false });
      if (error.response?.data?.message) {
        throw new ExceptionWithMessage(error.response.data.message);
      } else {
        throw new Error(error);
      }
    }
  },

  apply_labels: async ({ commit }, labelParams)=>{
    try {
      const response = await ContactAPI.applyLable(labelParams);
      return response
    } catch (error) {
      throw error
    }
  },


  export_account_contacts: async ({ commit }, exportParams) => {
    try {
      const response = await ContactAPI.exportAccountContacts(exportParams);
      return response
    } catch (e) {
      throw e
    }
  },

  fetchMeetingList: async ({commit}, id) => {
    try {
        const response = await ContactAPI.getContactMeetings(id);
        commit(types.FETCH_SCHEDULE_LIST, response.data);
    }catch (error) {
        throw new Error(error);
    }
  },
  import: async ({ commit }, file) => {
    commit(types.SET_CONTACT_UI_FLAG, { isCreating: true });
    try {
      await ContactAPI.importContacts(file);
      commit(types.SET_CONTACT_UI_FLAG, { isCreating: false });
    } catch (error) {
      commit(types.SET_CONTACT_UI_FLAG, { isCreating: false });
      if (error.response?.data?.message) {
        throw new ExceptionWithMessage(error.response.data.message);
      }
    }
  },
  importLead: async ({ commit }, file) => {
    commit(types.SET_CONTACT_UI_FLAG, { isCreating: true });
    try {
      const response = await ContactAPI.importLeads(file);
      return response
      commit(types.SET_CONTACT_UI_FLAG, { isCreating: false });
    } catch (error) {
      commit(types.SET_CONTACT_UI_FLAG, { isCreating: false });
      if (error.response?.data?.message) {
        throw new ExceptionWithMessage(error.response.data.message);
      }
    }
  },
  applyLabels: async ({ commit }, { selectedAudience, accountId }) => {
    commit(types.SET_CONTACT_UI_FLAG, { isCreating: true });
    try {
      const response = await ContactAPI.applyLabels(selectedAudience, accountId);
      return response;
    } catch (error) {
      if (error.response?.data?.message) {
        throw new ExceptionWithMessage(error.response.data.message);
      }
      throw error;
    } finally {
      commit(types.SET_CONTACT_UI_FLAG, { isCreating: false });
    }
  },
  labeledOneOffContacts: async ({ commit }, { selectedAudience, accountId }) => {
    commit(types.SET_CONTACT_UI_FLAG, { isCreating: true });
    try {
      const response = await ContactAPI.labeledOneOffContacts(selectedAudience, accountId);
      return response;
    } catch (error) {
      if (error.response?.data?.message) {
        throw new ExceptionWithMessage(error.response.data.message);
      }
      throw error;
    } finally {
      commit(types.SET_CONTACT_UI_FLAG, { isCreating: false });
    }
  },
  labeledEmailContacts: async ({ commit }, { selectedAudience, accountId }) => {
    commit(types.SET_CONTACT_UI_FLAG, { isCreating: true });
    try {
      const response = await ContactAPI.labeledEmailContacts(selectedAudience, accountId);
      return response;
    } catch (error) {
      if (error.response?.data?.message) {
        throw new ExceptionWithMessage(error.response.data.message);
      }
      throw error;
    } finally {
      commit(types.SET_CONTACT_UI_FLAG, { isCreating: false });
    }
  },
  createLeadsContact: async ({ commit }, leadsObj) => {
    commit(types.SET_CONTACT_UI_FLAG, { isCreating: true });
    try {
      const response = await ContactAPI.createLeadsContact(leadsObj);
      commit(types.SET_CONTACT_UI_FLAG, { isCreating: false });
      return response
    } catch (error) {
      commit(types.SET_CONTACT_UI_FLAG, { isCreating: false });
      if (error.response?.data?.message) {
        throw new ExceptionWithMessage(error.response.data.message);
      }
    }
  },

  get_stats: async ({ commit }, id) => {
    commit(types.SET_CONTACT_UI_FLAG, { isCreating: true });
    try {
      const response = await ContactAPI.get_stats(id);
      return response
    } catch (error) {
        throw new ExceptionWithMessage(error.response.data.message);
      }
  },

  get_records: async ({ commit }, id) => {
    commit(types.SET_CONTACT_UI_FLAG, { isCreating: true });
    try {
      const response = await ContactAPI.get_records(id);
      return response
    } catch (error) {
        throw new ExceptionWithMessage(error.response.data.message);
      }
  },
  get_email_records: async ({ commit }, id) => {
    commit(types.SET_CONTACT_UI_FLAG, { isCreating: true });
    try {
      const response = await ContactAPI.get_email_records(id);
      return response
    } catch (error) {
        throw new ExceptionWithMessage(error.response.data.message);
      }
  },

  pause_campaign: async ({ commit }, id) => {
    commit(types.SET_CONTACT_UI_FLAG, { isCreating: true });
    try {
      const response = await ContactAPI.pause_campaign(id);
      return response
    } catch (error) {
        throw new ExceptionWithMessage(error.response.data.message);
      }
  },

  play_campaign: async ({ commit }, id) => {
    commit(types.SET_CONTACT_UI_FLAG, { isCreating: true });
    try {
      const response = await ContactAPI.play_campaign(id);
      return response
    } catch (error) {
        throw new ExceptionWithMessage(error.response.data.message);
      }
  },

  createRecordStats: async ({ commit }, leadsObj) => {
    commit(types.SET_CONTACT_UI_FLAG, { isCreating: true });
    try {
      const response = await ContactAPI.createRecordStats(leadsObj);
      commit(types.SET_CONTACT_UI_FLAG, { isCreating: false });
      return response
    } catch (error) {
      commit(types.SET_CONTACT_UI_FLAG, { isCreating: false });
      if (error.response?.data?.message) {
        throw new ExceptionWithMessage(error.response.data.message);
      }
    }
  },

  createEmailRecordStats: async ({ commit }, leadsObj) => {
    commit(types.SET_CONTACT_UI_FLAG, { isCreating: true });
    try {
      const response = await ContactAPI.createEmailRecordStats(leadsObj);
      commit(types.SET_CONTACT_UI_FLAG, { isCreating: false });
      return response
    } catch (error) {
      commit(types.SET_CONTACT_UI_FLAG, { isCreating: false });
      if (error.response?.data?.message) {
        throw new ExceptionWithMessage(error.response.data.message);
      }
    }
  },
  getLeadsContact: async ({ commit }, leadsObj) => {
    commit(types.SET_CONTACT_UI_FLAG, { isCreating: true });
    try {
      const response = await ContactAPI.getLeadsContact(leadsObj);
      return response
      commit(types.SET_CONTACT_UI_FLAG, { isCreating: false });
    } catch (error) {
      commit(types.SET_CONTACT_UI_FLAG, { isCreating: false });
      if (error.response?.data?.message) {
        throw new ExceptionWithMessage(error.response.data.message);
      }
    }
  },

  delete: async ({ commit }, id) => {
    commit(types.SET_CONTACT_UI_FLAG, { isDeleting: true });
    try {
      await ContactAPI.delete(id);
      commit(types.SET_CONTACT_UI_FLAG, { isDeleting: false });
    } catch (error) {
      commit(types.SET_CONTACT_UI_FLAG, { isDeleting: false });
      if (error.response?.data?.message) {
        throw new Error(error.response.data.message);
      } else {
        throw new Error(error);
      }
    }
  },

  fetchContactableInbox: async ({ commit }, id) => {
    commit(types.SET_CONTACT_UI_FLAG, { isFetchingInboxes: true });
    try {
      const response = await ContactAPI.getContactableInboxes(id);
      const contact = {
        id,
        contactableInboxes: response.data.payload,
      };
      commit(types.SET_CONTACT_ITEM, contact);
    } catch (error) {
      if (error.response?.data?.message) {
        throw new ExceptionWithMessage(error.response.data.message);
      } else {
        throw new Error(error);
      }
    } finally {
      commit(types.SET_CONTACT_UI_FLAG, { isFetchingInboxes: false });
    }
  },

  updatePresence: ({ commit }, data) => {
    commit(types.UPDATE_CONTACTS_PRESENCE, data);
  },

  setContact({ commit }, data) {
    commit(types.SET_CONTACT_ITEM, data);
  },

  merge: async ({ commit }, { childId, parentId }) => {
    commit(types.SET_CONTACT_UI_FLAG, { isMerging: true });
    try {
      const response = await AccountActionsAPI.merge(parentId, childId);
      commit(types.SET_CONTACT_ITEM, response.data);
    } catch (error) {
      throw new Error(error);
    } finally {
      commit(types.SET_CONTACT_UI_FLAG, { isMerging: false });
    }
  },

  deleteContactThroughConversations: ({ commit }, id) => {
    commit(types.DELETE_CONTACT, id);
    commit(types.CLEAR_CONTACT_CONVERSATIONS, id, { root: true });
    commit(`contactConversations/${types.DELETE_CONTACT_CONVERSATION}`, id, {
      root: true,
    });
  },
};
